import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import imagem from '../../config/images';

import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { Context } from '../../Context/AuthContext';

import api from '../../config/configAPi';

export const Login = () => {
  const navigate = useNavigate();

  const { signIn } = useContext(Context);

  const [user, setUser] = useState({
    email: '',
    password: '',
  });

  const [status, setStatus] = useState({
    type: '',
    mensagem: '',
    loading: false,
  });

  const valorInput = (e) =>
    setUser({ ...user, [e.target.name]: e.target.value });

  const loginSubmit = async (e) => {
    e.preventDefault();

    // limpa a mensagem anterior antes de tentar de novo
    setStatus({ type: '', mensagem: '', loading: true });

    const headers = {
      'Content-type': 'application/json',
    };

    await api
      .post('/login', user, { headers })
      .then((response) => {
        setStatus({ type: '', mensagem: '', loading: false });
        localStorage.setItem('token', response.data.token);
        signIn(true);
        return navigate('/dashboard');
      })
      .catch((err) => {
        setStatus({
          type: 'error',
          mensagem: err.response
            ? err.response.data.mensagem
            : 'Não foi possível conectar ao servidor. Tente novamente.',
          loading: false,
        });
      });
  };

  return (
    <main className="loginWrap">
      <div className="loginCard">
        <div className="loginCabecalho">
          <img className="loginLogo" src={imagem.logo} alt="Logotipo" />
          <h1 className="loginTitulo">Acesso ao sistema</h1>
          <p className="loginSubtitulo">Recadastramento de ligações</p>
        </div>

        {status.type === 'error' ? (
          <p className="mensagemErro" role="alert">
            {status.mensagem}
          </p>
        ) : null}

        {status.type === 'success' ? (
          <p className="mensagemSucesso" role="status">
            {status.mensagem}
          </p>
        ) : null}

        <Form onSubmit={loginSubmit}>
          <Form.Group className="mb-3" controlId="loginEmail">
            <Form.Label>Usuário</Form.Label>
            <Form.Control
              type="email"
              name="email"
              placeholder="Digite o email"
              value={user.email}
              onChange={valorInput}
              autoComplete="username"
              autoFocus
              required
              disabled={status.loading}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="loginSenha">
            <Form.Label>Senha</Form.Label>
            <Form.Control
              type="password"
              name="password"
              placeholder="Digite a senha"
              value={user.password}
              onChange={valorInput}
              autoComplete="current-password"
              required
              disabled={status.loading}
            />
          </Form.Group>

          <Button
            className="loginBotao"
            variant={status.loading ? 'outline-success' : 'success'}
            type="submit"
            disabled={status.loading}
          >
            {status.loading ? 'Acessando...' : 'Acessar'}
          </Button>
        </Form>
      </div>
    </main>
  );
};
